import { render, staticRenderFns } from "./CitizenBuilder.vue?vue&type=template&id=1b58dd24&scoped=true"
import script from "./CitizenBuilder.vue?vue&type=script&lang=js"
export * from "./CitizenBuilder.vue?vue&type=script&lang=js"
import style0 from "./CitizenBuilder.vue?vue&type=style&index=0&id=1b58dd24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b58dd24",
  null
  
)

export default component.exports